import { trigger } from '@angular/animations';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { pgTransitionContentSwitch } from '../content-switch';
import { PgExpandableCardComponent } from '../pg-expandable-card/pg-expandable-card.component';

@Component({
  selector: 'pg-expandable-form-card, grit-expandable-form-card',
  exportAs: 'gritExpandableFormCard',
  templateUrl: './pg-expandable-form-card.component.html',
  styleUrls: ['./pg-expandable-form-card.component.scss'],
  animations: [trigger('transitionContent', pgTransitionContentSwitch)],
  encapsulation: ViewEncapsulation.None,
})
export class PgExpandableFormCardComponent implements OnInit {
  @ViewChild('expandCard', { static: true })
  expandCard: PgExpandableCardComponent;

  @Output()
  expandChange = new EventEmitter<boolean>();

  @Output()
  backdropClick = new EventEmitter<any>();

  @Output()
  cardClick = new EventEmitter<any>();

  @Input()
  bottomOffset = 0;

  @Input()
  originElement: HTMLElement;

  @Input()
  disableDefaultInteractions = false;

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {}

  expand() {
    return this.expandCard.expand();
  }
  collapse() {
    return this.expandCard.collapse();
  }

  handleBackdropClick() {
    if (!this.disableDefaultInteractions) {
      this.collapse();
    }
    this.backdropClick.emit();
  }

  handleCardClick() {
    if (!this.disableDefaultInteractions && !this.expandCard.expanded) {
      this.expand();
    }
    this.cardClick.emit();
  }

  handleExpandChange(expanded: boolean) {
    this.expandChange.emit(expanded);
  }
}
